import type { FC } from 'react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { parse, object, string, optional, number, picklist } from 'valibot';

import { ensureRouteAccess } from '@/lib/auth/guards';

const programOptions = ['CCM', 'RPM', 'TCM', 'BHI'] as const;
const programStatusOptions = [
	'consented',
	'qualified',
	'pending',
	'pending_review',
	'declined',
	'expired',
	'exhausted_attempts',
	'not_eligible',
	'rejected',
] as const;
const orderDirectionOptions = ['asc', 'desc'] as const;
const limitOptions = [10, 25, 50] as const;

const searchSchema = object({
	assigned_to: optional(string()),
	program: optional(picklist(programOptions)),
	program_status: optional(picklist(programStatusOptions)),
	search: optional(string()),
	page: optional(number()),
	limit: optional(picklist(limitOptions)),
	order_by_column: optional(string()),
	order_by_direction: optional(picklist(orderDirectionOptions)),
});

export const ReferralsLayout: FC = () => {
	return <Outlet />;
};

export const Route = createFileRoute('/(authenticated)/referrals')({
	validateSearch: (search) => {
		return parse(searchSchema, search);
	},
	beforeLoad: ensureRouteAccess('/referrals'),
	component: ReferralsLayout,
});
